<template>
  <div class="nx-signing-modal-merge-doc">
    <h4>{{$t('MergingSign')}}</h4>

    <h5 class="mt-4">{{$t('PleaseWait')}}</h5>

    <div class="mt-4">
      <b-spinner />
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";
import { SignApi } from "@/api";

export default {
  components: {
    BSpinner,
  },
  props: {
    value: {},
    isNonPdf: {
      type: Boolean,
      default: false
    },
    isDrawing: {
      type: Boolean,
      default: false
    },
    fileId:0
  },
  async created() {
    try {
      const { digest, signature } = this.value;
      // if(this.isNonPdf)
      // {
      //   await SignApi.mergeNonPdfSignature(this.fileId, signature.signature, signature.cert);
      // }
      // else
      // {
      //   await SignApi.mergeSignature(digest.digest, signature.signature, signature.cert);
      // }
      if (this.isDrawing) {
          await SignApi.mergeSignature(digest.digest, signature.signature, signature.cert);
      } else if (this.isNonPdf) {
          await SignApi.mergeNonPdfSignature(this.fileId, signature.signature, signature.cert);
      } else {
          await SignApi.mergeNormalPdfSignature(this.fileId, signature.signature, signature.cert);
      }
      

      this.$emit("next");
    } catch (ex) {
       if (ex.response) {
        this.$emit('input', ex.response.data);
        this.$emit('fail');
      } else {
        throw ex;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        MergingSign: 'Merging signature to document',
        PleaseWait: 'Please wait... Almost finish'
      },
      zh_hk: {
        MergingSign: '將簽名合併到文檔',
        PleaseWait: '請稍等...即將完成'
      },
      zh_cn: {
        MergingSign: '将签名合并到文档',
        PleaseWait: '请稍等...即将完成'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-merge-doc {
  text-align: center;
}
</style>
